import React, { useMemo } from "react";
import cn from "classnames";
import ContentPicker from "./ContentPicker";
import { DEEPLINKS } from "./templates";
import styles from "./DestinationField.module.sass";

const CUSTOM = "__custom__";

/**
 * DESTINO del botón. Escribir a mano `boostchinese://deck/<id>` es pedir erratas:
 * aquí se elige la pantalla de una lista y, si esa pantalla necesita un id, se
 * pide aparte. "Otra URL" sigue permitiendo cualquier enlace externo.
 */
const DestinationField = ({ value, onChange, disabled }) => {
  // El valor real es una sola string; la UI la descompone en pantalla + id.
  const { option, id } = useMemo(() => {
    const url = value || "";
    if (!url) return { option: DEEPLINKS[0], id: "" };
    const withId = DEEPLINKS.filter((d) => d.needsId).find((d) => url.startsWith(d.value));
    if (withId) return { option: withId, id: url.slice(withId.value.length) };
    const exact = DEEPLINKS.find((d) => d.value && d.value === url);
    if (exact) return { option: exact, id: "" };
    return { option: { value: CUSTOM, label: "Otra URL" }, id: "" };
  }, [value]);

  const pick = (next) => {
    if (next === CUSTOM) {
      onChange("https://");
      return;
    }
    const target = DEEPLINKS.find((d) => d.value === next);
    onChange(target?.needsId ? `${target.value}${id}` : next);
  };

  const isCustom = option.value === CUSTOM;

  return (
    <div className={styles.wrap}>
      <select
        className={cn(styles.select, styles.control)}
        value={option.value}
        disabled={disabled}
        onChange={(e) => pick(e.target.value)}
      >
        {DEEPLINKS.map((d) => (
          <option key={d.value || "none"} value={d.value}>
            {d.label}
          </option>
        ))}
        <option value={CUSTOM}>Otra URL (se abre en el navegador)</option>
      </select>

      {option.needsId && (
        <>
          {/* Buscar por nombre en vez de pegar un ObjectId a mano. */}
          <ContentPicker
            type={option.contentType}
            value={id ? { id, nombre: "" } : null}
            onSelect={(picked) => onChange(`${option.value}${picked.id}`)}
            disabled={disabled}
          />
          <input
            className={cn(styles.input, styles.control, styles.idInput)}
            placeholder={`…o pega el ${option.needsId}`}
            value={id}
            disabled={disabled}
            onChange={(e) => onChange(`${option.value}${e.target.value.trim()}`)}
          />
        </>
      )}

      {isCustom && (
        <input
          className={cn(styles.input, styles.control)}
          placeholder="https://…"
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
        />
      )}

      {value && (
        <div className={styles.resolved}>
          <code>{value}</code>
          {!isCustom && <span className={styles.badge}>abre dentro de la app</span>}
        </div>
      )}
    </div>
  );
};

export default DestinationField;
